
import { useEffect } from "react";

const HttpsRedirect = () => {
  useEffect(() => {
    // Only redirect if window is defined (browser) and not already on HTTPS
    if (
      typeof window !== "undefined" &&
      window.location.protocol === "http:"
    ) {
      const href = "https://" + window.location.host + window.location.pathname + window.location.search + window.location.hash;
      window.location.replace(href);
    }
  }, []);

  return null;
};

export default HttpsRedirect;
